import styled from 'styled-components';

export const QuickSectionStyle = styled.div`
  position: relative;

  .content-wrap {
    padding: 0 15px;

    @media (min-width: 1200px) {
      padding: 0 20px;
    }
  }
`;

export const BannerBlock = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 15px 15px 0;
  margin: 0 0 -40px;
  background: rgba(0, 203, 254, 0.05);

  @media (min-width: 1200px) {
    padding: 20px 20px 0;
    margin: 0 0 -58px;
  }
  @media (min-width: 1440px) {
    min-height: 280px;
  }

  .text-box {
    width: 100%;
    padding: 25px 0 70px;
    max-width: 600px;
    font-size: 14px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.5);

    @media (min-width: 1200px) {
      padding: 60px 0 74px;
    }


    p{
      margin: 0 0 20px;
    }
    
    button{
      padding: 7px 10px;
    }
  }

  h1 {
    font-size: 30px;
    line-height: 35px;
    font-weight: 600;

    @media (min-width: 1440px) {
      font-size: 41px;
      line-height: 45px;
    }
  }

  .img-box {
    align-self: flex-end;
    max-width: 405px;
    margin: 0 50px 0 0;
  }
`;
